/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 11:09:57
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-14 11:21:38
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: 'zh', // 语言标识
	messages: {
		zh: require('./zh.js'),
		en: require('./en.js')
	}
})

export default i18n
